var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, Button, AccordionSet, Accordion, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
var PublisherPrefixRangeDetail = function (_a) {
    var _b, _c, _d;
    var prefixRange = _a.prefixRange;
    var formatMessage = useIntl().formatMessage;
    var _e = useState({
        general: true,
        timestamps: true,
    }), accordionStatus = _e[0], setAccordionStatus = _e[1];
    var _f = useState(true), expandAll = _f[0], setExpandAll = _f[1];
    var renderField = function (label, value) { return (React.createElement(Row, { style: { marginBottom: "25px" } },
        React.createElement(Col, { xs: 12 },
            React.createElement("div", { style: { marginBottom: "5px" } },
                React.createElement("strong", { style: { fontSize: "1.1em", paddingRight: "5px" } }, label)),
            React.createElement("div", null, value !== undefined ? value : "N/A")))); };
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                general: false,
                timestamps: false,
            });
        }
        else {
            setAccordionStatus({
                general: true,
                timestamps: true,
            });
        }
        setExpandAll(!expandAll);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll
                    ? formatMessage({
                        id: "ui-br-agency.button.collapse",
                    })
                    : formatMessage({
                        id: "ui-br-agency.button.expand",
                    })))),
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { id: "general-info", label: "Obecn\u00E9 informace", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 }, renderField(formatMessage({
                        id: "ui-br-agency.publisher-prefix-range.field.label.agencyPrefix",
                    }), "".concat((_b = prefixRange.agencyPrefix) === null || _b === void 0 ? void 0 : _b.internationalPrefix.agency, " ").concat((_c = prefixRange.agencyPrefix) === null || _c === void 0 ? void 0 : _c.internationalPrefix.value, "-").concat((_d = prefixRange.agencyPrefix) === null || _d === void 0 ? void 0 : _d.value)))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 }, renderField(formatMessage({
                        id: "ui-br-agency.publisher-prefix-range.field.label.start",
                    }), prefixRange.start))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 }, renderField(formatMessage({
                        id: "ui-br-agency.publisher-prefix-range.field.label.end",
                    }), prefixRange.end))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 }, renderField(formatMessage({
                        id: "ui-br-agency.publisher-prefix-range.field.label.status",
                    }), prefixRange.status))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 }, renderField(formatMessage({
                        id: "ui-br-agency.publisher-prefix-range.field.label.nextSequence",
                    }), prefixRange.nextSequence)))))));
};
export default PublisherPrefixRangeDetail;
